
function getBaseProductPrice() {
  // 商品価格の要素からテキストを取得（テーマによりクラス名が異なる）
  let priceText = $('.price-item--regular').first().text().trim();

  // カンマや通貨記号（¥など）を取り除いて、数値化
  let price = parseInt(priceText.replace(/[^0-9]/g, ''), 10);

  return isNaN(price) ? 0 : price;
}

// spanを書き換える
function updateTotalPrice() {
  const basePrice = getBaseProductPrice();

  // オプション価格の取得
  var addonPrice = 0;
  // セレクトボックス
  $('#ymq-box .ymq-options-box select').each(function(i, elem){
    let optionPriceRaw = $(this).find('option:selected span.ymq-price-span').data('ymq-money');
    console.log($(this).find('option:selected').data('price'));
    let optionPrice = parseInt(optionPriceRaw, 10);
    addonPrice += isNaN(optionPrice) ? 0 : optionPrice;
  });
  
  // オプション価格表示のspan
  span = $('#ymq-addons-price');

  // 合計金額を計算
  let total = basePrice + addonPrice;

  console.log('基本価格:'+basePrice);
  console.log('オプション:'+addonPrice);
  console.log('合計金額:'+total.toLocaleString());

  // 合計金額を表示
  if (!$('#ymq-addons-price .ymq-price-span').length) {
    span.append('<span class="ymq-price-span">\u00A5'+total.toLocaleString()+'</span>');
  } else {
    $('#ymq-addons-price .ymq-price-span').html('\u00A5'+total.toLocaleString())
  }

  $('#ymq-addons-price .ymq-price-span').attr('style', 'display:block !important;');
}
$(function(){
  
  $(document).on('change keyup', '#ymq-box input, #ymq-box select', function(){
    $('#ymq-addons-price .ymq-price-span').attr('style', 'display:none !important;');
    setTimeout(function() {
      updateTotalPrice();
    }, 300); // 0.3秒待ってから初回実行
  });

  $(document).on('change', ".quantity__input[name='quantity']", function (){
    $('#ymq-addons-price .ymq-price-span').attr('style', 'display:none !important;');
      setTimeout(function() {
        updateTotalPrice();
      }, 500); // 0.5秒待ってから初回実行
  });

  // オプション額表示divが読み込まれたら合計表示を実行
  setTimeout(function() {
    updateTotalPrice();
  }, 300); 
})